A selling point of an advertisement product.

This details a reason why a user should choose this advertisement product over another.
